import type { CriminalAppellateDocumentRow, CriminalAppellateWizardDraft } from '../types/criminalAppellateCaseRequest';

export const DEFAULT_CRIMINAL_APPELLATE_DRAFT: CriminalAppellateWizardDraft = {
  fileCategory: '',
  fileCategoryId: '',
  subFileCategoryId: '',
  subFileCategoryName: '',
  applicableAreas: [],
  applicableAreaIds: [],
  instituteType: 'government',
  corporateInstitute: '',
  corporateInstituteName: '',
  corporateInstituteOther: '',
  corporateInstituteContactName: '',
  corporateInstitutePrefix: '',
  description: '',
  appealMatter: '',
  originalCourt: '',
  judgementOrderFileName: '',
  judgementOrderOriginalFileName: '',
  provinceId: '',
  provinceName: '',
  districtId: '',
  districtName: '',
  policeStationId: '',
  policeStationName: '',
  yourReferenceNumber: '',
  otherExternalReferences: '',
  caseNumber: '',
  hasConnectedMatters: 'no',
  connectedCaseNumber: '',
  connectedAgdFileRefAvailable: false,
  connectedAgdFileRef: '',
  plaintiffApplicantName: '',
  defendantRespondentName: '',
  clientType: 'government',
  otherInvolvedInstitutions: '',
  legalOfficerName: '',
  legalOfficerContact: '',
  urgencyLevelId: '',
  urgencyLevelName: '',
  deadline: '',
  urgencyJustification: '',
  deliveryMethodIds: [],
  deliveryMethods: [],
  deliveryOther: '',
  documents: [],
  confirmCorrect: false,
  draftRequestId: '',
  referenceNo: '',
};

export type CriminalAppellateWizardContextValue = {
  draft: CriminalAppellateWizardDraft;
  setDraft: React.Dispatch<React.SetStateAction<CriminalAppellateWizardDraft>>;
  reset: () => void;
};

export function syncAppellateDocumentsFromChecklist(
  prev: CriminalAppellateDocumentRow[],
  checklist: { id: string; documentTypeId: string; name: string; mandatory: boolean }[],
): CriminalAppellateDocumentRow[] {
  return checklist.map((item) => {
    const existing = prev.find(
      (d) => d.checklistItemId === item.id || d.documentTypeId === item.documentTypeId,
    );
    if (existing) {
      return {
        ...existing,
        checklistItemId: item.id,
        documentTypeId: item.documentTypeId,
        documentName: item.name,
        mandatory: item.mandatory,
      };
    }
    return {
      id: crypto.randomUUID(),
      checklistItemId: item.id,
      documentTypeId: item.documentTypeId,
      documentName: item.name,
      mandatory: item.mandatory,
      fileName: '',
      originalFileName: '',
      uploadTime: '',
      skipReason: '',
    };
  });
}
